// TODO: Check that the page is the right one so that this javascript doesn't affect other pages?
$("#search-form").submit(function(e){
    // Prevent submitting the form when it doesn't have all the necessary data
    if (!$("#productsInputId")[0].value || !$("#areasInputId")[0].value) {
        return false;
    }
});
